import { FC, useEffect, useRef, useState } from 'react'
import Modeler from 'bpmn-js/lib/Modeler'
import 'bpmn-js/dist/assets/diagram-js.css'
import 'bpmn-js/dist/assets/bpmn-js.css'
import React from 'react'
//@ts-ignore
// import lintModule from 'bpmn-js-bpmnlint'
//@ts-ignore
//import bpmnlintConfig from './bpmnlintconfig-packed'

import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'
import '@bpmn-io/properties-panel/assets/properties-panel.css'

import {
  BpmnPropertiesPanelModule,
  BpmnPropertiesProviderModule,
  CamundaPlatformPropertiesProviderModule, //@ts-ignore
} from 'bpmn-js-properties-panel'
import DocumentationEditorModule from '../extensions/bpmn/modules/documentation-editor'
import sistemivModdleDescriptors from '../extensions/bpmn/descriptors/sistemiv.json'
import SFormsModule from '../extensions/bpmn/modules/s-forms'

import CamundaBpmnModdle from 'camunda-bpmn-moddle/resources/camunda.json'
import { Button, DeleteModal } from '@sistemiv/s-components'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import EditableInput from './EditableInput'
import FilesAndDirectoriesService from '../../services/FilesAndDirectoriesService'
import { CheckIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { useDirectoryContent } from '../../repositories/directory/directoryContent.repository'
import { useProjectContent } from '../../repositories/project/projectContent.repository'
import Breadcrumbs from '../layout/Breadcrumbs'
import { useRenameItem } from '../../repositories/project-item/mutations/item-rename'
import BpmnViewerComponent from './BpmnViewerComponent'
import RaciPropertiesProvider from '../extensions/bpmn/modules/s-raci-editor'

const xml = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1nfetgs" targetNamespace="http://bpmn.io/schema/bpmn" xmlns:modeler="http://camunda.org/schema/modeler/1.0" exporter="Camunda Modeler" exporterVersion="5.35.0" modeler:executionPlatform="Camunda Platform" modeler:executionPlatformVersion="7.23.0">
  <bpmn:process id="Process_1" isExecutable="true" >
    <bpmn:startEvent id="StartEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
        <dc:Bounds x="182" y="162" width="36" height="36" />
      </bpmndi:BPMNShape>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`

type Props = {
  initialXml?: any
  file: string
  directoryPath: string
  //onSave: (xml: any) => void
}

const BpmnModeler: FC<Props> = ({ initialXml, file, directoryPath }) => {
  const canvas = useRef(null)
  const link = useRef(null)
  const modelerRef = useRef<Modeler | null>(null)
  //const fileInputRef = useRef<HTMLInputElement>(null)
  const { org, project } = useParams()
  //const [debouncedXml, setDebouncedXml] = useState<string | null>(null)
  const { t } = useTranslation()
  const [fileName, setFileName] = useState(file && file !== 'new' ? file : 'New BPMN diagram.bpmn')
  const [saved, setSaved] = useState(false)
  const [failed, setFailed] = useState(false)
  const { data: folderFiles } = useDirectoryContent(directoryPath)
  const { data: projectFiles } = useProjectContent()
  const [openWarningModal, setOpenWarningModal] = useState(false)
  // const [inputFocused, setInputFocused] = useState(false)
  const [saveLoading, setSaveloading] = useState(false)
  // const hasBeenSaved = useRef<boolean>(!!(file && file !== 'new'))

  const [viewerMode, setViewerMode] = useState(false)
  const [viewerXml, setViewerXml] = useState<string | null>(null)

  const toggleViewer = async () => {
    if (!modelerRef.current) return

    if (!viewerMode) {
      const { xml } = await modelerRef.current.saveXML({ format: true })
      setViewerXml(xml ?? null)
    }

    setViewerMode((prev) => !prev)
  }

  const { mutate: renameItem } = useRenameItem(directoryPath)

  // const handleRename = (newName: string) => {
  //   if (!hasBeenSaved.current) {
  //     setFileName(newName)
  //     return
  //   }
  //   if (newName === fileName) return
  //   renameItem(
  //     {
  //       organization: org!,
  //       path: `${project}/${directoryPath ? `${directoryPath}/` : ''}${fileName}`,
  //       newName,
  //       type: 'files',
  //     },
  //     {
  //       onSuccess: () => setFileName(newName),
  //       onError: () => {
  //         setFailed(true)
  //         setTimeout(() => {
  //           setFailed(false)
  //         }, 1000)
  //       },
  //     },
  //   )
  // }

  useEffect(() => {
    if (!canvas.current) return
    modelerRef.current = new Modeler({
      container: canvas.current!,
      // moddleExtensions: {
      //     custom: customModdleExtension
      // },
      propertiesPanel: {
        parent: '#js-properties-panel',
      },
      // linting: {
      //   bpmnlint: bpmnlintConfig,
      //   active: true,
      // },
      additionalModules: [
        BpmnPropertiesPanelModule,
        BpmnPropertiesProviderModule,
        //ZeebePropertiesProviderModule,
        CamundaPlatformPropertiesProviderModule,
        // lintModule,
        DocumentationEditorModule,
        SFormsModule,
        RaciPropertiesProvider,
      ],
      moddleExtensions: {
        //zeebe: zeebeModdle
        camunda: CamundaBpmnModdle,
        sistemiv: sistemivModdleDescriptors,
      },
      keyboard: {
        bindTo: document.body,
      },
    })

    //const savedXml = localStorage.getItem('autosave_bpmn')
    modelerRef.current
      // .importXML(savedXml || initialXml || xml)
      .importXML(initialXml || xml)
      //@ts-ignore
      .then(() => modelerRef.current?.get('canvas').zoom('fit-viewport'))
      .catch((error) => console.error('Error importing XML:', error))

    // const handleChange = async () => {
    //   try {
    //     const result = await modelerRef.current?.saveXML({ format: true })
    //     if (result?.xml) {
    //       setDebouncedXml(result.xml)
    //     }
    //   } catch (error) {
    //     console.error('Error saving XML:', error)
    //   }
    // }

    // const eventBus = modelerRef.current.get('eventBus')
    // //@ts-ignore
    // eventBus.on('commandStack.changed', handleChange)

    return () => {
      modelerRef.current?.destroy()
      modelerRef.current = null
    }
  }, [initialXml])

  useEffect(() => {
    const fetchAndLoadDiagram = async () => {
      try {
        const response = await FilesAndDirectoriesService.download(
          org!,
          `${project}/${directoryPath ? `${directoryPath}/${file}` : `${file}`}`,
          'files',
        )
        const contentType = response.headers['content-type']
        // Proveri da li je uspešno vraćen Blob
        // if (response.ok) {
        const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType })
        const text = await blob.text() // Pretvoriš Blob u tekst (XML)

        // Učitaj BPMN XML u modeler
        await modelerRef.current?.importXML(text)
        // }
      } catch (error) {
        console.error('Greška pri učitavanju BPMN dijagrama:', error)
      }
    }

    if (file && file !== 'new' && modelerRef.current) {
      fetchAndLoadDiagram()
    }
  }, [file, org, directoryPath, project])

  // Autosave na localStorage
  // useEffect(() => {
  //   if (debouncedXml) {
  //     const timeout = setTimeout(() => {
  //       localStorage.setItem('autosave_bpmn', debouncedXml)
  //       //onSave(debouncedXml)
  //     }, 2000)
  //     return () => clearTimeout(timeout)
  //   }
  // }, [debouncedXml])

  // Undo i Redo funkcije
  //@ts-ignore
  const handleUndo = () => modelerRef.current?.get('commandStack').undo()
  //@ts-ignore
  const handleRedo = () => modelerRef.current?.get('commandStack').redo()

  // Dodavanje tastaturnih prečica
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'z') {
        event.preventDefault()
        handleUndo()
      }
      if ((event.ctrlKey && event.key === 'y') || (event.ctrlKey && event.shiftKey && event.key === 'z')) {
        event.preventDefault()
        handleRedo()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  function setEncoded(link: any, name: string, data: any) {
    const encodedData = encodeURIComponent(data)

    if (data) {
      link.setAttribute('href', 'data:application/bpmn20-xml;charset=UTF-8,' + encodedData)
      link.setAttribute('download', name)
    } else {
      link.removeClass('active')
    }
  }
  const handleExport = async () => {
    //@ts-ignore
    const { xml } = await modelerRef.current.saveXML({ format: true })
    const downloadLink = link.current
    setEncoded(downloadLink, `${fileName}${!fileName.includes('.bpmn') ? '.bpmn' : ''}`, xml)
  }

  // const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0]
  //   if (file && modelerRef.current) {
  //     try {
  //       const fileContent = await file.text() // Čitanje fajla kao tekst
  //       await modelerRef.current.importXML(fileContent) // Import XML u modeler
  //       //@ts-ignore
  //       modelerRef.current.get('canvas').zoom('fit-viewport') // Zoomiranje na ceo dijagram
  //     } catch (error) {
  //       console.error('Error importing XML:', error)
  //       alert('Invalid BPMN file. Please upload a valid BPMN file.')
  //     }
  //   }
  // }

  // const triggerFileUpload = () => {
  //   fileInputRef.current?.click() // Otvara dijalog za odabir fajla
  // }

  const onSave = async () => {
    if (!modelerRef.current) return
    setSaveloading(true)
    try {
      const { xml } = await modelerRef.current.saveXML({ format: true })
      const blob = new Blob([xml!], { type: 'text/xml' })
      const file = new File([blob], `${fileName}${!fileName.includes('.bpmn') ? '.bpmn' : ''}`, { type: 'text/xml' })

      await FilesAndDirectoriesService.saveFile(
        org!,
        `${project}/${
          directoryPath
            ? `${directoryPath}/${fileName}${!fileName.includes('.bpmn') ? '.bpmn' : ''}`
            : `${fileName}${!fileName.includes('.bpmn') ? '.bpmn' : ''}`
        }`,
        file,
      )
      //alert('File saved successfully!')
      setSaved(true)
      setTimeout(() => {
        setSaved(false)
      }, 1000)
    } catch (error) {
      console.error('Error saving file:', error)
      // alert('Failed to save file.')
      setFailed(true)
      setTimeout(() => {
        setFailed(false)
      }, 1000)
    } finally {
      setSaveloading(false)
      if (openWarningModal) setOpenWarningModal(false)
    }
  }

  const handleRename = (newName: string) => {
    return new Promise<void>((resolve, reject) => {
      renameItem(
        {
          organization: org!,
          path: `${project}/${directoryPath ? `${directoryPath}/` : ''}${file}`,
          newName,
          type: 'files',
        },
        {
          onSuccess: () => {
            setFileName(newName)
            resolve()
          },
          onError: () => {
            setFailed(true)
            setTimeout(() => setFailed(false), 1000)
            reject()
          },
        },
      )
    })
  }

  // const handleSave = async () => {
  //   if (!modelerRef.current) return
  //   const files = directoryPath ? folderFiles : projectFiles
  //   if (
  //     (file === 'new' || fileName !== file) &&
  //     files.contents.find((file) =>
  //       fileName.includes('.') ? file.name === fileName : file.name.slice(0, file.name.lastIndexOf('.')) === fileName,
  //     )
  //   ) {
  //     setOpenWarningModal(true)
  //   } else onSave()
  // }

  const handleSave = async () => {
    if (!modelerRef.current) return
    const files = directoryPath ? folderFiles : projectFiles

    const fileExists = files.contents.find((file) =>
      fileName.includes('.') ? file.name === fileName : file.name.slice(0, file.name.lastIndexOf('.')) === fileName,
    )

    if (file === 'new' && fileExists) {
      setOpenWarningModal(true)
    } else {
      try {
        if (file && file !== 'new' && file !== fileName) {
          await handleRename(fileName)
        }
        await onSave()
      } catch (err) {
        console.error('Rename or save failed:', err)
      }
    }
  }

  return (
    <div className='w-ful h-full flex flex-col'>
      <div className='w-full h-16 flex justify-between border-b border-gray-300 items-center px-8'>
        <Breadcrumbs>
          {/* <EditableInput value={fileName} onRename={handleRename} setInputFocused={setInputFocused} /> */}
          <EditableInput value={fileName} onChange={setFileName} />
        </Breadcrumbs>
        <div className='flex gap-x-4'>
          <Button
            onClick={toggleViewer}
            className='border border-indigo-500 text-indigo-500 bg-white px-4 !py-1 rounded-md hover:bg-indigo-100'
          >
            {viewerMode ? t('backToEditor') : t('preview')}
          </Button>
          {failed && (
            <div className='flex items-center justify-center text-red-600 transition-opacity duration-500 ease-in-out opacity-100'>
              <ExclamationCircleIcon className='text-red-600 w-6 h-6 mr-2' /> <span>Failed to save</span>
            </div>
          )}
          {saved && !failed ? (
            <div className='flex items-center justify-center text-[#4B526C] transition-opacity duration-500 ease-in-out opacity-100'>
              <CheckIcon className='text-[#4B526C] w-6 h-6 mr-2' /> <span>Saved</span>
            </div>
          ) : (
            <Button
              className='border border-blue-500 text-blue-500 bg-white px-4 !py-1 rounded-md hover:bg-sky-100  transition-opacity duration-500 ease-in-out opacity-100 disabled:opacity-50 disabled:cursor-not-allowed'
              onClick={handleSave}
              // disabled={inputFocused}
            >
              {t('save')}
            </Button>
          )}
          <a id='js-download-diagram' download='MyExampleDoc' target='_blank' ref={link} onClick={handleExport}>
            <button
              id='js-download-diagram'
              className='border border-blue-500 text-blue-500 bg-white px-4 text-sm py-1 rounded-md hover:bg-sky-100 transition-colors duration-300'
            >
              {t('download')}
            </button>
          </a>
        </div>
      </div>
      <div className='w-full h-full flex relative'>
        <div
          ref={canvas}
          id='js-canvas'
          className='canvas absolute inset-0'
          style={{ display: viewerMode ? 'none' : 'block' }}
        ></div>

        <div
          id='js-properties-panel'
          className='properties-panel-parent absolute top-0 right-0 h-full bg-white'
          style={{ display: viewerMode ? 'none' : 'block' }}
        ></div>

        {viewerMode && viewerXml && <BpmnViewerComponent xml={viewerXml} />}
      </div>
      {!(viewerMode && viewerXml) && (
        <div className='h-16 py-4 px-8 border border-solid border-slate-300 flex items-center justify-between space-x-5'>
          <div className='flex items-center px-8 gap-x-5'>
            <Button
              onClick={handleUndo}
              className='border border-gray-500 text-gray-500 bg-white px-4 py-1 rounded hover:bg-gray-100'
            >
              Undo
            </Button>
            <Button
              onClick={handleRedo}
              className='border border-gray-500 text-gray-500 bg-white px-4 py-1 rounded hover:bg-gray-100'
            >
              Redo
            </Button>
          </div>
        </div>
      )}
      {openWarningModal && (
        <DeleteModal
          title={t('warning')}
          description={t('saveFileWarningMsg')}
          open={openWarningModal}
          setOpen={setOpenWarningModal}
          onDeleteConfirmed={onSave}
          actionLabel={t('continue')}
          isLoading={saveLoading}
        />
      )}
    </div>
  )
}

export default BpmnModeler
